import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faShieldAlt } from '@fortawesome/free-solid-svg-icons';
import { Button, Card, Col, Container, Form, Row } from '@themesberg/react-bootstrap';
import { Link, useHistory } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Routes } from '../../routes';
import { AlertMessage } from '../../components/PageHeader';

export default function Register() {
  const { register } = useAuth();
  const history = useHistory();
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [credentials, setCredentials] = useState(null);

  const handleRegister = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const data = await register(name.trim());
      setCredentials(data);
    } catch (err) {
      setError(err.message || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  const copy = (text) => navigator.clipboard.writeText(text);

  if (credentials) {
    return (
      <main>
        <Container className="py-5">
          <Row className="justify-content-center">
            <Col xs={12} lg={8}>
              <Card border="light" className="shadow-sm">
                <Card.Body className="p-4">
                  <h3 className="mb-3">Workspace created</h3>
                  <p className="text-gray">
                    Save these credentials now. The client secret is shown only once.
                  </p>
                  <AlertMessage variant="warning" message="Store the client secret securely before continuing." />
                  <Form.Group className="mb-3">
                    <Form.Label>Workspace name</Form.Label>
                    <Form.Control readOnly value={credentials.name} />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Tenant ID</Form.Label>
                    <div className="d-flex gap-2">
                      <Form.Control readOnly value={credentials.tenantId} />
                      <Button variant="outline-primary" onClick={() => copy(credentials.tenantId)}>Copy</Button>
                    </div>
                  </Form.Group>
                  <Form.Group className="mb-4">
                    <Form.Label>Client secret</Form.Label>
                    <div className="d-flex gap-2">
                      <Form.Control readOnly value={credentials.clientSecret} />
                      <Button variant="outline-primary" onClick={() => copy(credentials.clientSecret)}>Copy</Button>
                    </div>
                  </Form.Group>
                  <Button variant="primary" onClick={() => history.push(Routes.Login.path)}>
                    Continue to login
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </main>
    );
  }

  return (
    <main>
      <Container className="py-5">
        <Row className="justify-content-center">
          <Col xs={12} md={8} lg={6}>
            <div className="d-flex align-items-center justify-content-between mb-4">
              <Link to={Routes.Welcome.path} className="d-flex align-items-center text-decoration-none">
                <FontAwesomeIcon icon={faShieldAlt} className="text-primary me-2" />
                <span className="fw-bold text-primary">Flowfence</span>
              </Link>
              <Link to={Routes.Welcome.path} className="text-gray small">
                <FontAwesomeIcon icon={faAngleLeft} className="me-1" />
                Back to homepage
              </Link>
            </div>
            <Card border="light" className="shadow-sm">
              <Card.Body className="p-4 p-lg-5">
                <h3 className="mb-2">Create workspace</h3>
                <p className="text-gray mb-4">
                  Provision a new Flowfence workspace with encryption keys and signing credentials.
                </p>
                <AlertMessage variant="danger" message={error} onClose={() => setError('')} />
                <Form onSubmit={handleRegister}>
                  <Form.Group className="mb-3">
                    <Form.Label>Workspace name</Form.Label>
                    <Form.Control
                      required
                      maxLength={128}
                      placeholder="Acme Risk Ops"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </Form.Group>
                  <Button variant="primary" type="submit" className="w-100" disabled={loading || !name.trim()}>
                    {loading ? 'Creating workspace…' : 'Create workspace'}
                  </Button>
                </Form>
                <div className="text-center mt-4">
                  <span className="text-gray">Already have credentials? </span>
                  <Card.Link as={Link} to={Routes.Login.path}>Sign in</Card.Link>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </main>
  );
}
